import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import SecureOnlineBillPaymentForm from "@preferredMedical/Widgets/SecureOnlineBillPaymentForm/SecureOnlineBillPaymentForm";
import * as React from "react";
import { connect } from "react-redux";


const enum fields {
    emailRecipients = "emailRecipients",
    introductoryText = "introductoryText",
    maxTransactionAmount = "maxTransactionAmount",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
        [fields.introductoryText]: string;
        [fields.maxTransactionAmount]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    logInPageLink: getPageLinkByPageType(state, "SignInPage")?.url,
    currentPageUrl: getLocation(state),
});

type Props = WidgetProps & OwnProps & ReturnType<typeof mapStateToProps>;

const SecureOnlineBillPaymentFormWidget: React.FC<Props> = ({ fields, session, logInPageLink, currentPageUrl }) => {
    const { emailRecipients, introductoryText, maxTransactionAmount } = fields;
    const isLoggedIn = (session.isAuthenticated || session.rememberMe) && !session.isGuest;

    return (
        <StyledWrapper>
            {!isLoggedIn && <Typography>Please <Link href={`${logInPageLink}?returnUrl=${encodeURIComponent(currentPageUrl.pathname)}`}>Log in</Link> to view this page.</Typography>}
            {isLoggedIn && <SecureOnlineBillPaymentForm emailRecipients={emailRecipients} introductoryText={introductoryText} maxTransactionAmount={maxTransactionAmount}/>}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SecureOnlineBillPaymentFormWidget),
    definition: {
        displayName: "Secure Online Bill Payment Form",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.emailRecipients,
                displayName: "Email recipients (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.introductoryText,
                displayName: "Introductory Text",
                editorTemplate: "RichTextField",
                fieldType: "General",
                defaultValue:
                    "Please enter your billing information. All fields required.",
                isRequired: true,
            },
            {
                name: fields.maxTransactionAmount,
                displayName: "Maximum Transaction Amount",
                editorTemplate: "IntegerField",
                fieldType: "General",
                defaultValue:
                    999999,
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
